import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GiHamburgerMenu } from "react-icons/gi";

import NavLeft from './NavLeft';
import NavRight from './NavRight';

import { ConfigContext } from '../../../contexts/ConfigContext';
import * as actionType from '../../../store/actions';
import NavList from './NavList';
import { getSessionStorage } from '../../../utils/helpers';

const NavBar = () => {
  const [moreToggle, setMoreToggle] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const configContext = useContext(ConfigContext);
  const { collapseMenu, headerFixedLayout, layout } = configContext.state;
  const { dispatch } = configContext;
  const permissionLevel = getSessionStorage('PERMISSION_LEVEL');
  const userType = getSessionStorage('USER_TYPE');

  // Handle window resize and reset mobile menu state when switching to desktop
  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWindowWidth(newWidth);
      
      // If switching from mobile to desktop, close mobile menu
      if (newWidth >= 992 && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [mobileMenuOpen]);
  
  let headerClass = ['navbar', 'pcoded-header', 'navbar-expand-lg'];
  if (headerFixedLayout && layout === 'vertical') {
    headerClass = [...headerClass, 'headerpos-fixed'];
  }

  let toggleClass = ['mobile-menu'];
  if (collapseMenu) {
    toggleClass = [...toggleClass, 'on'];
  }

  const navToggleHandler = () => {
    dispatch({ type: actionType.COLLAPSE_MENU });
  };

  const mobileToggleHandler = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  let moreClass = ['mob-toggler'];
  let collapseClass = ['collapse navbar-collapse'];
  
  if (moreToggle) {
    moreClass = [...moreClass, 'on'];
    collapseClass = [...collapseClass, 'show'];
  }

  // Add mobile menu state to collapse class only for mobile view
  if (mobileMenuOpen && windowWidth < 992) {
    collapseClass = [...collapseClass, 'show'];
  }

  // Check if we're in desktop mode
  const isDesktop = windowWidth >= 992;

  let navBar = (
    <>
      <div className="m-header">
        <Link to="#" className={toggleClass.join(' ')} id="mobile-collapse" onClick={navToggleHandler}>
          <span />
        </Link>
        
        {/* Mobile layout: hamburger + logo in center + right nav */}
        <div className="mobile-nav-row d-lg-none">
          <button 
            className={`navbar-toggler ${mobileMenuOpen ? 'collapsed' : ''}`}
            type="button"
            onClick={mobileToggleHandler}
            aria-controls="navbarNav"
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle navigation"
          >
            <GiHamburgerMenu size={24} color="$menu-color" />
          </button>
          
          <div className="mobile-logo-center">
            <NavLeft />
          </div>
          
          <div className="mobile-nav-right">
            <NavRight />
          </div>
        </div>
      </div>
      
      {/* Desktop layout */}
      <div 
        className={`${collapseClass.join(' ')} d-none d-lg-flex`}
        style={{ justifyContent: 'space-between' }}
        id="navbarNav"
      >
        {/* Always show NavLeft and NavRight in desktop mode */}
        {isDesktop && <NavLeft />}
        {userType == 'Internal' && <NavList mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />}
        {isDesktop && <NavRight />}
      </div>
    </>
  );

  return (
    <React.Fragment>
      <header className={headerClass.join(' ')}
      style={{
        backgroundImage: 'linear-gradient(90deg, rgb(37, 0, 86) 4.5%, rgb(0, 118, 174) 100%)',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1030,
        height: '50px',
        color: '#fff',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
      }}>{navBar}</header>
    </React.Fragment>
  );
};

export default NavBar;